export const PAYMENT_LINK_APIS = {
  generate_payment_link: "payments/exly/link/generate",
  update_payment_link: "payments/exly/link/update",
  validate_payment_link: "payments/validate/link/generation",
  generate_qr: "payments/exly/qr/generate",
  attach_customer: "payments/exly/qr/attach/customer",
  qr_list: "payments/exly/qr/list",
};
export const CREATE_COMBO_PAYMENT_LINK = "payments/exly/link/generate/combo";
export const FETCH_PAYMENT_LINK = "payments/exly/dynamiclink";
export const DUPLICATE_PAYMENT_LINK = "payments/exly/link/duplicate";
export const OFFERING_VARIANT_GET = "host/offering/variant/get";
